import axios from 'axios'
import config from '../config/app'

const widgetAPI = {
  getCurrentUserGivingWidgetSettings () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/widget/auth-giving').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getGivingWidgetSettingsByKey (key) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/widget/giving?key=' + key).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateGivingWidget (settings) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/widget/giving', settings).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getImpactWidgetByCompanyId (companyId) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/widget/impact?company_id=' + companyId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getImpactWidgetById (widgetId) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/widget/impact?id=' + widgetId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  // Added because conflict of routes in live and stage
  getImpactWidgetByIdNew (widgetId) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/widget/impact/new?id=' + widgetId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCurrentUserImpactWidget () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/widget/impact').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateTotalImpactWidget (settings) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/widget/impact', settings).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getImpactHiveWidgetByIdNew (widgetId) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/widget/impact/hive/new?id=' + widgetId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateTotalImpactHiveWidget (settings) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/widget/impact/hive', settings).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getLeverageImpactWidgetById (widgetId) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/widget/impact/leverage?id=' + widgetId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  // Added because conflict of routes in live and stage
  getLeverageImpactWidgetByIdNew (widgetId) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/widget/impact/leverage/new?id=' + widgetId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getWidgetUserLog (widgetId) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/widget/trackwidgetusers/' + widgetId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCurrentUserLeverageImpactWidget (id) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/widget/impact/leverage?id=' + id).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCurrentUserHiveImpactWidget (id) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/widget/hive?id=' + id).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateLeveragedImpactWidget (settings) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/widget/impact/leverage', settings).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCommunityImpact () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/total-stat-exclduid').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCampaignWidget (filters, additionalFields) {
    let query = (additionalFields !== null && additionalFields !== undefined) ? 'additional=' + additionalFields.join(',') + '&' : ''
    if (filters !== undefined) {
      query += Object.keys(filters).map(function (key) {
        return key + '=' + filters[key]
      }).join('&')
    }
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/campaign?' + query).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getGoalsSDG () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/widget/goalsSDG').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCompnayDowngradeStatus (key) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/campaign/getCompanyDowngradeStatus/?key=' + key).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCurrentUserSDGWidgetSettings () {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
      axios.get(config.server + '/user/widget/sdg').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCurrentUserGlobalImpactWidgetSettings () {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
      axios.get(config.server + '/user/widget/global-impacts').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateSDGWidget (settings) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/widget/sdg', settings).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateGlobalImpactWidget (settings) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/widget/global-impact', settings).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getMapWidgetSettings () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/widget/map').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getGoalWidgetSettings () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/widget/goal').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getGoalWidgetSettingsById (companyId) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/widget/goal?id=' + companyId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateMapWidget (settings) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/widget/map', settings).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateGoalWidget (settings) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/widget/goal', settings).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  sendSegment (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/widget/send-widget', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}

export default widgetAPI



// WEBPACK FOOTER //
// ./src/api/widget.js